import React, { useEffect, useState } from "react";
import parsePhoneNumber from "libphonenumber-js";
import "./GlobalTalent.css";
import { API_BASE_URL } from "./config";

// import globeDesktop from "./assets/global-network-globe.png";
// import globeMobile from "./assets/global-network-globe-mobile.png";

const TalentOpportunitySection = () => {

  const [activeTab, setActiveTab] = useState("jobs");

  const [showModal, setShowModal] = useState(false);



  const initialFormData = {
    fullName: "",
    email: "",
    phone: "",
    phoneCountry: "IN",

    country: "",
    city: "",
    currentRole: "",
    experience: "",
    skills: "",
    currentCompany: "",
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    linkedin: "",
    github: "",
    portfolio: "",
    preferredLocations: "",
    workPreference: "",
    relocation: "",
    resume: null,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  const phoneCountries = [
    { code: "IN", name: "India", callingCode: "91" },
    { code: "US", name: "United States", callingCode: "1" },
    { code: "GB", name: "United Kingdom", callingCode: "44" },
    { code: "CA", name: "Canada", callingCode: "1" },
    { code: "AU", name: "Australia", callingCode: "61" },
    { code: "DE", name: "Germany", callingCode: "49" },
    { code: "FR", name: "France", callingCode: "33" },
    { code: "SG", name: "Singapore", callingCode: "65" },
    { code: "JP", name: "Japan", callingCode: "81" },
    { code: "KR", name: "South Korea", callingCode: "82" },
    { code: "AE", name: "UAE", callingCode: "971" },
  ];




  const handleChange = (e) => {
    const { name, value } = e.target;

    let cleanValue = value;

    // Names: letters, spaces, apostrophe, dot and hyphen only
    if (name === "fullName") {
      cleanValue = value.replace(/[^\p{L}\s.'-]/gu, "");
    }

    // City: letters, spaces, apostrophe and hyphen
    if (name === "city") {
      cleanValue = value.replace(/[^\p{L}\s.'-]/gu, "");
    }

    // Phone: digits only
    if (name === "phone") {
      cleanValue = value.replace(/\D/g, "").slice(0, 15);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: cleanValue,
    }));

    // Remove error while user corrects field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    const fullName = formData.fullName.trim();
    const email = formData.email.trim();
    const city = formData.city.trim();
    const role = formData.currentRole.trim();
    const skills = formData.skills.trim();


    // -----------------------------
    // FULL NAME
    // -----------------------------
    if (!fullName) {
      newErrors.fullName = "Full name is required.";
    } else if (fullName.length < 2) {
      newErrors.fullName = "Enter at least 2 characters.";
    } else if (fullName.length > 50) {
      newErrors.fullName = "Maximum 50 characters allowed.";
    } else if (!/^[\p{L}\s.'-]+$/u.test(fullName)) {
      newErrors.fullName = "Name can contain letters only.";
    }


    // -----------------------------
    // EMAIL
    // -----------------------------
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (email.length > 100) {
      newErrors.email = "Email is too long.";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email)
    ) {
      newErrors.email = "Enter a valid email address.";
    }


    // -----------------------------
    // GLOBAL PHONE NUMBER
    // -----------------------------
    if (!formData.phone) {
      newErrors.phone = "Mobile number is required.";
    } else {
      try {
        const parsedPhone = parsePhoneNumber(
          formData.phone,
          formData.phoneCountry
        );

        if (!parsedPhone || !parsedPhone.isValid()) {
          const selectedCountry = phoneCountries.find(
            (country) => country.code === formData.phoneCountry
          );

          newErrors.phone =
            `Enter a valid mobile number for ${selectedCountry?.name || "the selected country"
            }.`;
        }
      } catch {
        newErrors.phone = "Enter a valid mobile number.";
      }
    }


    // -----------------------------
    // COUNTRY
    // -----------------------------
    if (!formData.country.trim()) {
      newErrors.country = "Country is required.";
    } else if (formData.country.length > 60) {
      newErrors.country = "Maximum 60 characters allowed.";
    }


    // -----------------------------
    // CITY
    // -----------------------------
    if (!city) {
      newErrors.city = "Current city is required.";
    } else if (city.length > 60) {
      newErrors.city = "Maximum 60 characters allowed.";
    } else if (!/^[\p{L}\s.'-]+$/u.test(city)) {
      newErrors.city = "Enter a valid city name.";
    }


    // -----------------------------
    // CURRENT ROLE
    // -----------------------------
    if (!role) {
      newErrors.currentRole = "Current role is required.";
    } else if (role.length > 80) {
      newErrors.currentRole =
        "Maximum 80 characters allowed.";
    }


    // -----------------------------
    // EXPERIENCE
    // -----------------------------
    if (!formData.experience) {
      newErrors.experience =
        "Please select your total experience.";
    }


    // -----------------------------
    // CURRENT COMPANY
    // -----------------------------
    if (
      formData.currentCompany &&
      formData.currentCompany.trim().length > 100
    ) {
      newErrors.currentCompany =
        "Maximum 100 characters allowed.";
    }


    // -----------------------------
    // SKILLS
    // -----------------------------
    if (!skills) {
      newErrors.skills =
        "Please enter your primary skills.";
    } else if (skills.length < 2) {
      newErrors.skills =
        "Please enter valid skills.";
    } else if (skills.length > 300) {
      newErrors.skills =
        "Maximum 300 characters allowed.";
    }


    // -----------------------------
    // CTC
    // -----------------------------
    if (
      formData.currentCTC &&
      formData.currentCTC.length > 30
    ) {
      newErrors.currentCTC =
        "Maximum 30 characters allowed.";
    }

    if (
      formData.expectedCTC &&
      formData.expectedCTC.length > 30
    ) {
      newErrors.expectedCTC =
        "Maximum 30 characters allowed.";
    }


    // -----------------------------
    // PREFERRED LOCATIONS
    // -----------------------------
    if (
      formData.preferredLocations &&
      formData.preferredLocations.length > 150
    ) {
      newErrors.preferredLocations =
        "Maximum 150 characters allowed.";
    }


    // -----------------------------
    // LINKEDIN
    // -----------------------------
    if (
      formData.linkedin &&
      !/^https?:\/\/(www\.)?linkedin\.com\/.+/i.test(
        formData.linkedin.trim()
      )
    ) {
      newErrors.linkedin =
        "Enter a valid LinkedIn profile URL.";
    }


    // -----------------------------
    // GITHUB
    // -----------------------------
    if (
      formData.github &&
      !/^https?:\/\/(www\.)?github\.com\/.+/i.test(
        formData.github.trim()
      )
    ) {
      newErrors.github =
        "Enter a valid GitHub profile URL.";
    }


    // -----------------------------
    // PORTFOLIO
    // -----------------------------
    if (formData.portfolio) {
      try {
        new URL(formData.portfolio);
      } catch {
        newErrors.portfolio =
          "Enter a valid website URL.";
      }
    }


    // -----------------------------
    // RESUME
    // -----------------------------
    if (!formData.resume) {
      newErrors.resume = "Resume is required.";
    } else {
      const allowedExtensions = [
        "pdf",
        "doc",
        "docx",
      ];

      const extension =
        formData.resume.name
          .split(".")
          .pop()
          ?.toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        newErrors.resume =
          "Only PDF, DOC and DOCX files are allowed.";
      }

      // 5 MB maximum
      const maxSize = 5 * 1024 * 1024;

      if (formData.resume.size > maxSize) {
        newErrors.resume =
          "Resume must be smaller than 5 MB.";
      }
    }


    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const parsedPhone = parsePhoneNumber(
    formData.phone,
    formData.phoneCountry
  );

  const internationalPhone =
    parsedPhone?.number || formData.phone;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      const firstErrorField =
        document.querySelector(".field-error");

      if (firstErrorField) {
        firstErrorField.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      return;
    }

    // Keep reference so we can also clear file input
    const formElement = e.currentTarget;

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("full_name", formData.fullName);
      formDataToSend.append("email", formData.email);
      formDataToSend.append(
        "phone",
        internationalPhone
      );

      formDataToSend.append("country", formData.country);
      formDataToSend.append("city", formData.city);

      formDataToSend.append("current_role", formData.currentRole);
      formDataToSend.append("experience", formData.experience);

      formDataToSend.append("skills", formData.skills);

      formDataToSend.append(
        "current_company",
        formData.currentCompany || ""
      );

      formDataToSend.append(
        "current_ctc",
        formData.currentCTC || ""
      );

      formDataToSend.append(
        "expected_ctc",
        formData.expectedCTC || ""
      );

      formDataToSend.append(
        "notice_period",
        formData.noticePeriod || ""
      );

      formDataToSend.append(
        "linkedin",
        formData.linkedin || ""
      );

      formDataToSend.append(
        "github",
        formData.github || ""
      );

      formDataToSend.append(
        "portfolio",
        formData.portfolio || ""
      );

      formDataToSend.append(
        "preferred_locations",
        formData.preferredLocations || ""
      );

      formDataToSend.append(
        "work_preference",
        formData.workPreference || ""
      );

      formDataToSend.append(
        "relocation",
        formData.relocation || ""
      );

      if (formData.resume) {
        formDataToSend.append(
          "resume",
          formData.resume
        );
      }


      const response = await fetch(
        `${API_BASE_URL}/global-talent/register`,
        {
          method: "POST",
          body: formDataToSend,
        }
      );


      const result = await response.json();


      if (!response.ok) {
        throw new Error(
          result.detail ||
          "Profile submission failed"
        );
      }


      console.log(
        "Global Talent Registration:",
        result
      );


      /* ==============================
         SUCCESS
      ============================== */

      setShowModal(true);


      // Clear React-controlled fields
      setFormData(initialFormData);
      setErrors({});


      // Clears file input + native form state
      formElement.reset();


      setTimeout(() => {

        setShowModal(false);


        // Go to very top of Global Talent page
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

      }, 3000);


    } catch (error) {

      console.error(
        "Global Talent submission error:",
        error
      );

      alert(
        error.message ||
        "Unable to submit profile. Please try again."
      );

    }
  };


  return (

    <section className="talent-opportunity-section">

      {/* SIMPLE EXPERIENCED PROFESSIONAL HEADER */}

      <div className="professional-simple-header">

        <span>
          EXPERIENCED PROFESSIONALS
        </span>

        <h2>
          Find Roles That Match Your Experience
        </h2>

        <p>
          Browse current opportunities or submit your professional profile
          so we can match you with relevant roles.
        </p>

        <div className="professional-actions">

          <button
            className={
              activeTab === "jobs"
                ? "professional-action active"
                : "professional-action"
            }
            onClick={() => setActiveTab("jobs")}
          >
            Browse Jobs
            <span>{openPositions.length}</span>
          </button>

          <button
            className={
              activeTab === "profile"
                ? "professional-action active"
                : "professional-action"
            }
            onClick={() => setActiveTab("profile")}
          >
            Upload Resume
          </button>

        </div>

      </div>



      {/* ===================================
          OPEN POSITIONS
      =================================== */}

      {activeTab === "jobs" && (

        <div className="jobs-container">

          <div className="jobs-top">

            <div>
              <h3>Open Positions</h3>

              <p>
                Browse current opportunities across AI, Data, Software and Cloud.
              </p>
            </div>


            <div className="live-jobs-badge">

              <span></span>

              Live Opportunities

            </div>

          </div>



          <div className="jobs-grid">

            {openPositions.map((job) => (

              <article
                className="job-card"
                key={job.id}
              >

                <div className="job-card-top">

                  <span className="job-category">
                    {job.category}
                  </span>

                  <span className="job-id">
                    #{String(job.id).padStart(2, "0")}
                  </span>

                </div>


                <h3>
                  {job.title}
                </h3>


                <p className="job-company">
                  {job.company}
                </p>


                <div className="job-meta">

                  <span>
                    📍 {job.location}
                  </span>

                  <span>
                    ◉ {job.workType}
                  </span>

                  <span>
                    ◷ {job.experience}
                  </span>

                </div>


                <div className="job-skills">

                  {job.skills.map((skill) => (

                    <span key={skill}>
                      {skill}
                    </span>

                  ))}

                </div>


                <div className="job-salary">

                  <small>
                    COMPENSATION
                  </small>

                  <strong>
                    {job.salary}
                  </strong>

                </div>


                <a
                  href={job.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="job-view-button"
                >
                  View Position
                  <span>↗</span>
                </a>

              </article>

            ))}

          </div>

        </div>

      )}



      {/* ===================================
          CREATE PROFILE
      =================================== */}

      {activeTab === "profile" && (

        <div className="registration-wrapper">


          <div className="registration-intro">

            <span>
              SUBMIT YOUR PROFILE
            </span>


            <h3>
              Submit Your Professional Profile
            </h3>


            <p>
              Add your career details and resume for relevant opportunity matching.
            </p>


            <div className="registration-points">

              <div>✓ AI-powered resume matching</div>

              <div>✓ Relevant global opportunities</div>

              <div>✓ Structured interview process</div>

              <div>✓ Selection & onboarding support</div>

            </div>

          </div>



          <form
            className="global-registration-form"
            onSubmit={handleSubmit}
          >

            <div className="form-title">

              <h3>
                Professional Registration
              </h3>

              <p>
                Complete your profile carefully.
              </p>

            </div>



            <div className="form-grid">

              {/* FULL NAME */}
              <div className="form-field">
                <label>Full Name *</label>

                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Your full name"
                  minLength={2}
                  maxLength={50}
                  autoComplete="name"
                  required
                />

                {errors.fullName && (
                  <small className="field-error">
                    {errors.fullName}
                  </small>
                )}
              </div>


              {/* EMAIL */}
              <div className="form-field">
                <label>Email *</label>

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="professional@email.com"
                  maxLength={100}
                  autoComplete="email"
                  required
                />

                {errors.email && (
                  <small className="field-error">
                    {errors.email}
                  </small>
                )}
              </div>


              {/* MOBILE */}
              <div className="form-field">
                <label>Mobile Number *</label>

                <div className="global-phone-input">

                  <select
                    name="phoneCountry"
                    value={formData.phoneCountry}
                    onChange={handleChange}
                    aria-label="Country calling code"
                  >
                    {phoneCountries.map((country) => (
                      <option
                        key={country.code}
                        value={country.code}
                      >
                        {country.code} +{country.callingCode}
                      </option>
                    ))}
                  </select>

                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Mobile number"
                    inputMode="numeric"
                    autoComplete="tel-national"
                    maxLength={15}
                    required
                  />

                </div>

                {errors.phone && (
                  <small className="field-error">
                    {errors.phone}
                  </small>
                )}
              </div>


              {/* COUNTRY */}
              <div className="form-field">
                <label>Country *</label>

                <select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    Select country
                  </option>

                  {phoneCountries.map((country) => (
                    <option
                      key={country.code}
                      value={country.name}
                    >
                      {country.name}
                    </option>
                  ))}
                </select>

                {errors.country && (
                  <small className="field-error">
                    {errors.country}
                  </small>
                )}
              </div>


              {/* CITY */}
              <div className="form-field">
                <label>Current City *</label>

                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Mumbai"
                  maxLength={60}
                  autoComplete="address-level2"
                  required
                />

                {errors.city && (
                  <small className="field-error">
                    {errors.city}
                  </small>
                )}
              </div>


              {/* CURRENT ROLE */}
              <div className="form-field">
                <label>Current Role *</label>

                <input
                  type="text"
                  name="currentRole"
                  value={formData.currentRole}
                  onChange={handleChange}
                  placeholder="AI Engineer"
                  maxLength={80}
                  required
                />

                {errors.currentRole && (
                  <small className="field-error">
                    {errors.currentRole}
                  </small>
                )}
              </div>


              {/* EXPERIENCE */}
              <div className="form-field">
                <label>Total Experience *</label>

                <select
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option>Fresher</option>
                  <option>0 - 1 Year</option>
                  <option>1 - 3 Years</option>
                  <option>3 - 5 Years</option>
                  <option>5 - 8 Years</option>
                  <option>8 - 12 Years</option>
                  <option>12+ Years</option>
                </select>

                {errors.experience && (
                  <small className="field-error">
                    {errors.experience}
                  </small>
                )}
              </div>


              {/* CURRENT COMPANY */}
              <div className="form-field">
                <label>Current Company</label>

                <input
                  type="text"
                  name="currentCompany"
                  value={formData.currentCompany}
                  onChange={handleChange}
                  placeholder="Company name"
                  maxLength={100}
                />

                {errors.currentCompany && (
                  <small className="field-error">
                    {errors.currentCompany}
                  </small>
                )}
              </div>


              {/* SKILLS */}
              <div className="form-field full">
                <label>Primary Skills *</label>

                <input
                  type="text"
                  name="skills"
                  value={formData.skills}
                  onChange={handleChange}
                  placeholder="Python, AI, React, AWS, Docker..."
                  maxLength={300}
                  required
                />

                {errors.skills && (
                  <small className="field-error">
                    {errors.skills}
                  </small>
                )}
              </div>


              {/* CURRENT CTC */}
              <div className="form-field">
                <label>Current CTC</label>

                <input
                  type="text"
                  name="currentCTC"
                  value={formData.currentCTC}
                  onChange={handleChange}
                  placeholder="₹12 LPA"
                  maxLength={30}
                />

                {errors.currentCTC && (
                  <small className="field-error">
                    {errors.currentCTC}
                  </small>
                )}
              </div>


              {/* EXPECTED CTC */}
              <div className="form-field">
                <label>Expected CTC</label>

                <input
                  type="text"
                  name="expectedCTC"
                  value={formData.expectedCTC}
                  onChange={handleChange}
                  placeholder="₹18 LPA"
                  maxLength={30}
                />

                {errors.expectedCTC && (
                  <small className="field-error">
                    {errors.expectedCTC}
                  </small>
                )}
              </div>


              {/* NOTICE PERIOD */}
              <div className="form-field">
                <label>Notice Period</label>

                <select
                  name="noticePeriod"
                  value={formData.noticePeriod}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option>Immediate</option>
                  <option>15 Days</option>
                  <option>30 Days</option>
                  <option>60 Days</option>
                  <option>90 Days</option>
                </select>
              </div>


              {/* WORK PREFERENCE */}
              <div className="form-field">
                <label>Work Preference</label>

                <select
                  name="workPreference"
                  value={formData.workPreference}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option>Remote</option>
                  <option>Hybrid</option>
                  <option>On-site</option>
                  <option>Any</option>
                </select>
              </div>


              {/* PREFERRED LOCATIONS */}
              <div className="form-field full">
                <label>Preferred Locations</label>

                <input
                  type="text"
                  name="preferredLocations"
                  value={formData.preferredLocations}
                  onChange={handleChange}
                  placeholder="India, UAE, Singapore, UK, Remote..."
                  maxLength={150}
                />

                {errors.preferredLocations && (
                  <small className="field-error">
                    {errors.preferredLocations}
                  </small>
                )}
              </div>


              {/* LINKEDIN */}
              <div className="form-field">
                <label>LinkedIn</label>

                <input
                  type="url"
                  name="linkedin"
                  value={formData.linkedin}
                  onChange={handleChange}
                  placeholder="https://linkedin.com/in/username"
                  maxLength={250}
                />

                {errors.linkedin && (
                  <small className="field-error">
                    {errors.linkedin}
                  </small>
                )}
              </div>


              {/* GITHUB */}
              <div className="form-field">
                <label>GitHub</label>

                <input
                  type="url"
                  name="github"
                  value={formData.github}
                  onChange={handleChange}
                  placeholder="https://github.com/username"
                  maxLength={250}
                />

                {errors.github && (
                  <small className="field-error">
                    {errors.github}
                  </small>
                )}
              </div>


              {/* PORTFOLIO */}
              <div className="form-field full">
                <label>Portfolio / Personal Website</label>

                <input
                  type="url"
                  name="portfolio"
                  value={formData.portfolio}
                  onChange={handleChange}
                  placeholder="https://yourwebsite.com"
                  maxLength={250}
                />

                {errors.portfolio && (
                  <small className="field-error">
                    {errors.portfolio}
                  </small>
                )}
              </div>


              {/* RESUME */}
              <div className="form-field full">
                <label>Resume *</label>

                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => {

                    const file = e.target.files?.[0] || null;

                    if (!file) {
                      setFormData((prev) => ({
                        ...prev,
                        resume: null,
                      }));
                      return;
                    }

                    const extension = file.name
                      .split(".")
                      .pop()
                      ?.toLowerCase();

                    const allowedExtensions = [
                      "pdf",
                      "doc",
                      "docx",
                    ];

                    const maxSize =
                      5 * 1024 * 1024;

                    if (!allowedExtensions.includes(extension)) {

                      setErrors((prev) => ({
                        ...prev,
                        resume:
                          "Only PDF, DOC and DOCX files are allowed.",
                      }));

                      setFormData((prev) => ({
                        ...prev,
                        resume: null,
                      }));

                      e.target.value = "";
                      return;
                    }

                    if (file.size > maxSize) {

                      setErrors((prev) => ({
                        ...prev,
                        resume:
                          "Resume must be smaller than 5 MB.",
                      }));

                      setFormData((prev) => ({
                        ...prev,
                        resume: null,
                      }));

                      e.target.value = "";
                      return;
                    }

                    setFormData((prev) => ({
                      ...prev,
                      resume: file,
                    }));

                    setErrors((prev) => ({
                      ...prev,
                      resume: "",
                    }));
                  }}
                  required
                />

                <small className="resume-hint">
                  PDF, DOC or DOCX • Maximum 5 MB
                </small>

                {errors.resume && (
                  <small className="field-error">
                    {errors.resume}
                  </small>
                )}
              </div>

            </div>



            <label className="form-consent">

              <input
                type="checkbox"
                required
              />

              <span>
                I agree that StudyAIPlacement Global Talent may
                process my professional information for
                relevant career opportunities.
              </span>

            </label>



            <button
              type="submit"
              className="profile-submit-button"
            >
              Submit Professional Profile
              <span>→</span>
            </button>

          </form>

        </div>

      )}



      {/* ===================================
          3 SECOND AI MODAL
      =================================== */}

      {showModal && (

        <div className="ai-modal-overlay">

          <div className="ai-profile-modal">

            <div className="ai-loader">

              <div></div>

              <span>
                AI
              </span>

            </div>


            <h3>
              Profile Submitted Successfully
            </h3>

            <p>
              Your professional profile has been securely received.
              Our AI matching engine is preparing your profile for
              evaluation against relevant global opportunities.
            </p>

            <div className="ai-processing">
              <span></span>
              Preparing profile for AI evaluation...
            </div>



          </div>

        </div>

      )}

    </section>

  );

};

const openPositions = [
  {
    id: 1,
    company: "Torc Robotics",
    title: "ML Engineer II - Simulation Enablement",
    location: "USA / Canada",
    workType: "Remote",
    category: "AI / Machine Learning",
    experience: "Experienced",
    salary: "$153,200 - $183,800 USD",
    skills: ["Python", "ML", "Ray", "AWS", "Sensor Data"],
    url: "https://boards.greenhouse.io/torcrobotics/jobs/8651349002",
  },

  {
    id: 2,
    company: "Temporal",
    title: "Staff Software Engineer - AI Foundations",
    location: "USA / Canada",
    workType: "Remote",
    category: "AI Engineering",
    experience: "Staff",
    salary: "Salary not disclosed",
    skills: ["Python", "TypeScript", "AI Agents", "Go", "Java"],
    url: "https://boards.greenhouse.io/temporaltechnologies/jobs/5204483007",
  },

  {
    id: 3,
    company: "Abnormal AI",
    title: "Software Engineer II - Identity Security",
    location: "Singapore",
    workType: "Remote",
    category: "Software Engineering",
    experience: "Mid Level",
    salary: "Salary not disclosed",
    skills: ["Backend", "APIs", "Distributed Systems", "Security"],
    url: "https://boards.greenhouse.io/abnormalsecurity/jobs/7807807003",
  },

  {
    id: 4,
    company: "Flexport",
    title: "Senior Software Engineer - Applied AI",
    location: "Amsterdam, Netherlands",
    workType: "On-site / Hybrid",
    category: "AI / Software",
    experience: "Senior",
    salary: "Salary not disclosed",
    skills: ["AI", "Software Engineering", "Python", "Cloud"],
    url: "https://boards.greenhouse.io/flexport",
  },

  {
    id: 5,
    company: "Trustpilot",
    title: "Data Scientist - Applied AI",
    location: "London / Copenhagen / Edinburgh",
    workType: "Hybrid",
    category: "Data Science",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Python", "Machine Learning", "NLP", "Recommendation"],
    url: "https://boards.greenhouse.io/trustpilot/jobs/7817520",
  },

  {
    id: 6,
    company: "PhysicsX",
    title: "Data Scientist",
    location: "Singapore",
    workType: "On-site",
    category: "Data Science",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Python", "AI", "Data Science", "Engineering"],
    url: "https://boards.greenhouse.io/physicsx",
  },

  {
    id: 7,
    company: "PhysicsX",
    title: "Machine Learning Engineer",
    location: "Singapore",
    workType: "On-site",
    category: "Machine Learning",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Python", "ML", "Deep Learning", "Cloud"],
    url: "https://boards.greenhouse.io/physicsx",
  },

  {
    id: 8,
    company: "PhysicsX",
    title: "Machine Learning Engineer",
    location: "New York, USA",
    workType: "On-site",
    category: "Machine Learning",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Python", "ML", "AI", "Engineering"],
    url: "https://boards.greenhouse.io/physicsx",
  },

  {
    id: 9,
    company: "PhysicsX",
    title: "Machine Learning Engineer",
    location: "San Francisco, USA",
    workType: "On-site",
    category: "Machine Learning",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Machine Learning", "Python", "AI", "Data"],
    url: "https://boards.greenhouse.io/physicsx",
  },

  {
    id: 10,
    company: "PhysicsX",
    title: "Senior Machine Learning Engineer",
    location: "London, UK",
    workType: "On-site / Hybrid",
    category: "Machine Learning",
    experience: "Senior",
    salary: "Salary not disclosed",
    skills: ["ML", "Python", "Deep Learning", "AI"],
    url: "https://boards.greenhouse.io/physicsx",
  },

  {
    id: 11,
    company: "PhysicsX",
    title: "Machine Learning Software Engineer - Research",
    location: "London, UK",
    workType: "On-site / Hybrid",
    category: "AI Research",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Python", "ML", "Research", "Software Engineering"],
    url: "https://boards.greenhouse.io/physicsx",
  },

  {
    id: 12,
    company: "GetYourGuide",
    title: "Senior AI/ML Ops Engineer",
    location: "Berlin, Germany",
    workType: "Hybrid",
    category: "MLOps",
    experience: "Senior",
    salary: "Salary not disclosed",
    skills: ["MLOps", "Cloud", "ML", "Kubernetes"],
    url: "https://boards.greenhouse.io/getyourguide",
  },

  {
    id: 13,
    company: "GetYourGuide",
    title: "Senior Data Scientist - Growth Data Products",
    location: "Berlin, Germany",
    workType: "Hybrid",
    category: "Data Science",
    experience: "Senior",
    salary: "Salary not disclosed",
    skills: ["Python", "Statistics", "ML", "Data Science"],
    url: "https://boards.greenhouse.io/getyourguide",
  },

  {
    id: 14,
    company: "GetYourGuide",
    title: "Staff Data Scientist - Growth Data Products",
    location: "Berlin, Germany",
    workType: "Hybrid",
    category: "Data Science",
    experience: "Staff",
    salary: "Salary not disclosed",
    skills: ["Data Science", "ML", "Experimentation", "Python"],
    url: "https://boards.greenhouse.io/getyourguide",
  },

  {
    id: 15,
    company: "Robots & Pencils",
    title: "AI Engineer",
    location: "Bogota, Colombia",
    workType: "Remote Friendly",
    category: "AI Engineering",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["AI", "Python", "LLMs", "Cloud"],
    url: "https://boards.greenhouse.io/robotsandpencils",
  },

  {
    id: 16,
    company: "Robots & Pencils",
    title: "Staff Full Stack Engineer",
    location: "Canada",
    workType: "Remote / Hybrid",
    category: "Full Stack",
    experience: "Staff",
    salary: "Salary not disclosed",
    skills: ["React", "Backend", "APIs", "Cloud"],
    url: "https://boards.greenhouse.io/robotsandpencils/jobs/5372981008",
  },

  {
    id: 17,
    company: "Robots & Pencils",
    title: "Principal Data Scientist",
    location: "United States",
    workType: "Remote",
    category: "Data Science",
    experience: "Principal",
    salary: "Salary not disclosed",
    skills: ["Data Science", "ML", "Python", "AI"],
    url: "https://boards.greenhouse.io/robotsandpencils",
  },

  {
    id: 18,
    company: "Chime",
    title: "Senior AI/ML Engineer",
    location: "USA",
    workType: "Multiple Locations",
    category: "AI / Machine Learning",
    experience: "Senior",
    salary: "Salary not disclosed",
    skills: ["AI", "ML", "Python", "Production Systems"],
    url: "https://boards.greenhouse.io/chime",
  },

  {
    id: 19,
    company: "Chime",
    title: "Software Engineer - AI Enablement",
    location: "United States",
    workType: "Remote",
    category: "AI / Software",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["AI", "Software Engineering", "Cloud", "APIs"],
    url: "https://boards.greenhouse.io/chime",
  },

  {
    id: 20,
    company: "Liftoff",
    title: "Machine Learning Engineer",
    location: "California, USA",
    workType: "Remote",
    category: "Machine Learning",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Machine Learning", "Python", "Data", "Cloud"],
    url: "https://boards.greenhouse.io/liftoff/jobs/7028524",
  },

  {
    id: 21,
    company: "Liftoff",
    title: "Software Engineer - ML Data",
    location: "San Francisco Bay Area",
    workType: "Hybrid",
    category: "ML / Data Engineering",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["ML", "Data Engineering", "Python", "Distributed Systems"],
    url: "https://boards.greenhouse.io/liftoff/jobs/7028524",
  },

  {
    id: 22,
    company: "Gatik",
    title: "Senior / Staff Full-Stack Engineer - Simulation Platform",
    location: "Santa Clara, USA",
    workType: "On-site",
    category: "Full Stack / Autonomous AI",
    experience: "Senior / Staff",
    salary: "Salary not disclosed",
    skills: ["Full Stack", "Simulation", "Cloud", "Autonomous Systems"],
    url: "https://boards.greenhouse.io/gatikaiinc/jobs/4620826006",
  },

  {
    id: 23,
    company: "Inovalon",
    title: "Principal Health Data Scientist",
    location: "United States",
    workType: "Remote",
    category: "Data Science",
    experience: "Principal",
    salary: "Salary not disclosed",
    skills: ["Data Science", "ML", "Healthcare Data", "Python"],
    url: "https://boards.greenhouse.io/inovalon/jobs/7602139003",
  },

  {
    id: 24,
    company: "Inovalon",
    title: "Java Full Stack Developer",
    location: "Gurugram, India",
    workType: "On-site / Hybrid",
    category: "Full Stack",
    experience: "Experienced",
    salary: "Salary not disclosed",
    skills: ["Java", "Full Stack", "APIs", "Cloud"],
    url: "https://boards.greenhouse.io/inovalon/jobs/7602139003",
  },
];


// const countries = [
//   { name: "USA", flag: "/images/flags/us.png" },
//   { name: "UK", flag: "/images/flags/uk.png" },
//   { name: "Canada", flag: "/images/flags/canada.png" },
//   { name: "Germany", flag: "/images/flags/germany.png" },
//   { name: "France", flag: "/images/flags/france.png" },
//   { name: "Australia", flag: "/images/flags/australia.png" },
//   { name: "Singapore", flag: "/images/flags/singapore.png" },
//   { name: "Japan", flag: "/images/flags/japan.png" },
//   { name: "South Korea", flag: "/images/flags/korea.png" },
//   { name: "UAE", flag: "/images/flags/uae.png" },
//   { name: "India", flag: "/images/flags/india.png" },
// ];

const countries = [
  { name: "USA", code: "us" },
  { name: "UK", code: "gb" },
  { name: "Canada", code: "ca" },
  { name: "Germany", code: "de" },
  { name: "France", code: "fr" },
  { name: "Australia", code: "au" },
  { name: "Singapore", code: "sg" },
  { name: "Japan", code: "jp" },
  { name: "South Korea", code: "kr" },
  { name: "UAE", code: "ae" },
  { name: "India", code: "in" },
];
const reviews = [
  {
    name: "Michael Harrington",
    role: "Head of Engineering",
    country: "United States",
    flag: "/images/flags/us.png",
    photo: "/images/reviews/Michael-Harrington.png",
    review:

      "Earlier, our team spent too much time screening profiles that looked strong on paper but did not match the actual role. The structured matching and interview process made shortlisting far more focused, helping us reach candidates who were technically relevant and ready to contribute.",

  },
  {
    name: "Eleanor Whitmore",
    role: "Talent Acquisition Lead",
    country: "United Kingdom",
    flag: "/images/flags/uk.png",
    photo: "/images/reviews/eleanor-whitmore.png",
    review:
      "Finding experienced technology professionals across different skill sets used to involve multiple tools and long screening cycles. Having registration, resume matching, interviews and selection in one process makes hiring much simpler and gives our team a clearer view of every candidate.",
  },
  {
    name: "Lukas Falkenberg",
    role: "Technology Hiring Manager",
    country: "Germany",
    flag: "/images/flags/germany.png",
    photo: "/images/reviews/lukas-falkenberg.png",
    review:
      "The biggest challenge was not getting applications; it was finding people whose experience genuinely matched what the team needed. Skill-focused resume matching reduces that noise and allows us to spend interview time with candidates who are much closer to the requirement.",
  },
  {
    name: "Camille Delacroix",
    role: "People & Technology Leader",
    country: "France",
    flag: "/images/flags/france.png",
    photo: "/images/reviews/camille-delacroix.png",
    review:
      "From a company perspective, the value is in reducing unnecessary screening while still keeping the final hiring decision human. Candidates arrive with better context about the opportunity, and hiring teams get a more organised pipeline from discovery through onboarding.",
  },
  {
    name: "Renjiro Takamura",
    role: "AI & Product Leader",
    country: "Japan",
    flag: "/images/flags/japan.png",
    photo: "/images/reviews/renjiro-takamura.png",
    review:
      "For professionals, good skills alone are not always enough if their profile never reaches the right company. A matching-driven network gives strong candidates a better chance to be evaluated for roles aligned with their actual experience instead of applying randomly.",
  },
  {
    name: "Noura Al Zayedi",
    role: "Digital Transformation Lead",
    country: "UAE",
    flag: "/images/flags/uae.png",
    photo: "/images/reviews/aisha-mansoori.png",
    review:
      "Hiring across fast-moving technology teams can become fragmented very quickly. A single flow from candidate registration to matching, interview, selection and onboarding creates much better visibility and helps companies focus on productive, role-ready professionals.",
  },
  {
    name: "Rohan Vardhan",
    role: "Senior Technology Professional",
    country: "India",
    flag: "/images/flags/india.png",
    photo: "/images/reviews/rohan-vardhan.png",
    review:
      "For candidates, one of the hardest parts is understanding which opportunities genuinely fit their background. Instead of sending the same resume everywhere, a structured matching process can connect professionals with more relevant roles and make the interview journey much more purposeful.",
  },
];

const steps = [
  {
    number: "01",
    title: "Register",
    text: "Create your professional profile",
  },
  {
    number: "02",
    title: "Resume Matching by AI",
    text: "Resume matched with relevant company requirements",
  },
  {
    number: "03",
    title: "Interview & Selection",
    text: "Technical interview and evaluation",
  },
  {
    number: "04",
    title: "Onboarding",
    text: "Selection to successful joining",
  },
];

const GlobalTalent = () => {



  const [isMobile, setIsMobile] = useState(window.innerWidth <= 650);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 650);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="global-page">

      <section className="global-hero">


        <div
          className="global-globe-bg"
          style={{
            backgroundImage: `url(${isMobile
              ? `${process.env.PUBLIC_URL}/images/global-network-globe-mobile.png`
              : `${process.env.PUBLIC_URL}/images/global-network-globe.png`
              })`,
          }}
        ></div>



        <div className="global-dark-overlay" />

        <div className="global-content">

          {/* Brand */}
          <div className="global-brand">
            <img
              src={`${process.env.PUBLIC_URL}/images/global-talent-logo.png`}
              alt="StudyAIPlacement Global Talent"
            />

            <span>STUDYAIPLACEMENT GLOBAL TALENT</span>
          </div>


          {/* Heading */}
          <div className="global-title-area">

            <p className="global-small-title">
              GLOBAL TECH TALENT NETWORK
            </p>

            <h1>
              Connecting Skilled Tech Talent
              <br />

              <span>
                with <strong>Global Companies</strong>
              </span>
            </h1>

            <p className="global-domain">
              AI <i>•</i> DATA <i>•</i> SOFTWARE <i>•</i> CLOUD
            </p>

          </div>


          {/* FLAG STRIP */}
          <div className="country-strip">

            <div className="country-track">

              {[...countries, ...countries].map((country, index) => (

                <div
                  className="country-item"
                  key={`${country.name}-${index}`}
                >

                  <img
                    src={`https://flagcdn.com/w80/${country.code}.png`}
                    alt={`${country.name} flag`}
                  />

                  <span>{country.name}</span>

                </div>

              ))}

            </div>

          </div>


          {/* PROCESS */}
          <div className="hero-process">
            {steps.map((step, index) => (
              <React.Fragment key={step.number}>

                <div className="hero-process-card">

                  {/* <span className="step-number">
                    {step.number}
                  </span> */}

                  <h3>{step.title}</h3>

                  <div className="process-gold-line"></div>

                  {/* <p>{step.text}</p> */}

                </div>


                {index < steps.length - 1 && (
                  <div
                    className={
                      isMobile
                        ? "mobile-flow-arrow"
                        : "process-arrow process-arrow-desktop"
                    }
                  >
                    ›
                  </div>
                )}

              </React.Fragment>
            ))}
          </div>

        </div>

      </section>

      


      {/* FORM STARTS IMMEDIATELY AFTER FIRST SCREEN */}

      <section className="candidate-form-section" id="register">

        <section className="global-reviews">

          <div className="reviews-heading">
            <span>GLOBAL PERSPECTIVES</span>
            <h2>What Technology Leaders Say</h2>
          </div>

          <div className="reviews-marquee">

            <div className="reviews-track">

              {[...reviews, ...reviews].map((review, index) => (

                <article
                  className="review-card"
                  key={`${review.name}-${index}`}
                >

                  <div className="review-top">

                    <img
                      src={review.photo}
                      alt={review.name}
                      className="review-photo"
                    />

                    <div>
                      <h3>{review.name}</h3>

                      <p className="review-role">
                        {review.role} • {review.company}
                      </p>

                      <div className="review-country">
                        <img
                          src={review.flag}
                          alt={review.country}
                        />
                        <span>{review.country}</span>
                      </div>
                    </div>

                  </div>

                  <p className="review-text">
                    “{review.review}”
                  </p>

                </article>

              ))}

            </div>

          </div>

          <div className="review-dots">
            <span className="active"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>

        </section>



      </section>

      <TalentOpportunitySection />

    </div>
  );
};

export default GlobalTalent;